import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { kycServices } from '../../services/kyc-service'

export const PENDING_LIMIT_REQUEST_CTA = 'Request under review'
export const ALREADY_SUBMITTED_LIMIT_REQUEST_CODE = 'investment-limit-request-already-submitted'
export const ALREADY_SUBMITTED_LIMIT_REQUEST_MESSAGE =
  'You already have an investment limit request under review.'

export const getApiErrorCode = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined
  }

  const responseData = (error as { response?: { data?: { code?: string; error?: string } } })
    .response?.data
  return responseData?.code || responseData?.error
}

export const usePendingInvestmentLimitRequest = () => {
  const authToken = useSelector((state: RootState) => state.investor.authToken)
  const [hasPendingRequest, setHasPendingRequest] = useState(false)

  const refresh = useCallback(async () => {
    if (!authToken) {
      setHasPendingRequest(false)
      return false
    }

    try {
      const response = await kycServices.getMyInvestmentLimitRequest({
        Authorization: authToken,
      })
      const pending = response?.status === 200 && response.data?.hasPendingRequest === true
      setHasPendingRequest(pending)
      return pending
    } catch {
      return false
    }
  }, [authToken])

  useEffect(() => {
    void refresh()
  }, [refresh])

  const markPending = useCallback(() => {
    setHasPendingRequest(true)
  }, [])

  const openIfAllowed = useCallback(
    async (open: () => void) => {
      const pending = await refresh()
      if (pending) {
        return
      }
      open()
    },
    [refresh],
  )

  return { hasPendingRequest, refresh, markPending, openIfAllowed }
}
